<template>
   <NuxtLink
      v-if="link"
      :to="link"
      class="__clickable bg-light-grey rounded-small p-1.5"
      @click.stop.prevent="() => {}"
   >
      <Icon name="arrow-top-right-on-square" />
   </NuxtLink>
</template>

<script lang="ts" setup>
type Props = {
   link: string
}

const props = withDefaults(defineProps<Props>(), {})
</script>
